import basicRequest, { POST_REQUEST, PUT_REQUEST } from '../../../core/redux/actions/request'

import { notification } from 'antd'

const PREFIX = 'JOB_SHOW'
const getState = (state) => state.job.show

const {
  getPattern,

  actionPostPattern,
  actionPutPattern,
  actionDeletePattern,

  requestPattern,

  success,
  reset,
  secondaryError,
  secondaryLoading,
  isSecondaryLoading,
  secondarySuccess,
  secondaryReset: formReset,

  isLoaded,
  isLoading,
  getError,
  getData,

  getSecondarySuccess: getFormSuccess,
  getSecondaryError: getFormError,

  generalDownload
} = basicRequest(PREFIX, getState)

export const load = (id) => getPattern('react/v1/jobs/' + id, {}, null)

export { reset, isLoading, isLoaded, getError, getData, getFormSuccess, getFormError, formReset, isSecondaryLoading }

/**
 * PATRON COMPLEJO: Analizarlo, en el success quiere hacer success del primario y del secundario a la vez
 */

const onSuccess = (message) => (dispatch) => {
  notification.success(message)
  dispatch(secondarySuccess(true))
};

export const updateTask = (jobId, taskId, form) =>
  requestPattern(
        `react/v1/jobs/${jobId}/tasks/${taskId}`,
        PUT_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Task was updated'
        })
  )

export const createTask = (id, form) =>
  requestPattern(
        `react/v1/jobs/${id}/tasks`,
        POST_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Task was created'
        })
  )

export const editLQA = (jobId, lqaId, form) =>
  requestPattern(
        `react/v1/jobs/${jobId}/lqa/${lqaId}`,
        PUT_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Job was updated'
        })
  )

export const createLQA = (id, form) =>
  requestPattern(
        `react/v1/jobs/${id}/lqa`,
        POST_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Job was created'
        })
  )

export const createLQAComment = (id, lqaId, form) =>
  requestPattern(
        `react/v1/jobs/${id}/lqa/${lqaId}/comment`,
        POST_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Job was created'
        })
  )

export const updateTaskVendorModal = (jobId, taskId, form) =>
  requestPattern(
        `react/v1/jobs/${jobId}/tasks/${taskId}/update-vendor`,
        PUT_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        success,
        onSuccess({
          message: 'Update',
          description: 'The Task was updated'
        })
  )

/**
 * Fin patron complejo
 */

export const updateTaskVendor = (id, taskId, form) =>
  actionPutPattern('react/v1/jobs/' + id + '/tasks/' + taskId + '/update-vendor', form, {
    message: 'Update',
    description: 'The Job was updated'
  })

export const updateStatus = (id, form) =>
  actionPutPattern('react/v1/jobs/' + id + '/update-status', form, {
    message: 'Update',
    description: 'The Job was updated'
  })

export const updatePrices = (id) =>
  actionPutPattern(
    'react/v1/jobs/' + id + '/update-prices',
    {},
    {
      message: 'Update',
      description: 'The Job was updated'
    }
  )

export const updateTaskStatus = (id, taskId, form) =>
  actionPutPattern('react/v1/jobs/' + id + '/tasks/' + taskId + '/update-status', form, {
    message: 'Update',
    description: 'The Task was updated'
  })

export const clientConfirmation = (id) =>
  actionPutPattern(
    'react/v1/jobs/' + id + '/client-status',
    { status: 'Confirmed' },
    {
      message: 'Update',
      description: 'The Job was updated'
    }
  )

export const removeTask = (id, taskId) => actionDeletePattern(
  'react/v1/jobs/' + id + '/tasks/' + taskId,
  {},
  {
    message: 'Delete',
    description: 'The Task was deleted'
  }
)

export const removeLqa = (jobId, id) => actionDeletePattern(
  'react/v1/jobs/' + jobId + '/lqa/' + id,
  {},
  {
    message: 'LQA',
    description: 'The Job was updated'
  }
)

export const removeLqaComment = (jobId, lqaId, commentId) => actionDeletePattern(
  `react/v1/jobs/${jobId}/lqa/${lqaId}/comment/${commentId}`,
  {},
  {
    message: 'LQA',
    description: 'The Job was updated'
  }
)

export const removeFromPO = (id) => actionDeletePattern(
  'react/v1/jobs/purchaseOrder/' + id,
  {},
  {
    message: 'Purchase Order',
    description: 'The Job was removed from the Purchase Order'
  }
)

export const createStorage = (id, form) => actionPostPattern('react/v2/jobs/' + id + '/storage', form)

export const removeScorecard = (id, qaId) => actionDeletePattern(
  `react/v1/jobs/${id}/qa/${qaId}/scorecard`,
  {},
  {
    message: 'Updated',
    description: 'The scorecard has been deleted!'
  }
)

export const uploadScorecard = (id, qaId, form) => actionPostPattern(`react/v1/jobs/${id}/qa/${qaId}/scorecard`, form, {
  message: 'Updated',
  description: 'The invoice has been uploaded!'
})

export const downloadScorecard = (id, qaId, name) => generalDownload(`react/v1/jobs/${id}/qa/${qaId}/scorecard`, name)

export const postBitacoraMessage = (id, form) =>
  actionPostPattern(`react/v1/jobs/${id}/bitacora`, form)
